import { render, staticRenderFns } from "./Parutions.vue?vue&type=template&id=6546418b&scoped=true&"
import script from "./Parutions.vue?vue&type=script&lang=js&"
export * from "./Parutions.vue?vue&type=script&lang=js&"
import style0 from "./Parutions.vue?vue&type=style&index=0&id=6546418b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6546418b",
  null
  
)

export default component.exports